"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertGetContractTemplateToFittec = convertGetContractTemplateToFittec;
function convertGetContractTemplateToFittec(studioId, config) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var data = {
        tenantKey: config.get.tenantKey,
        fittecId: config.get.fittecId,
        studioId: studioId,
    };
    var provider = (_a = config.get.technologyType) !== null && _a !== void 0 ? _a : 'magicline';
    if (provider === 'yond') {
        if (!((_c = (_b = config.get.yond) === null || _b === void 0 ? void 0 : _b.studioLocationMapping) === null || _c === void 0 ? void 0 : _c[studioId])) {
            console.error('Selected studio', studioId, 'has NO set tariff ids in the webflow settings, showing ALL tarifs!');
        }
        data.provider = {
            name: 'yond',
            filter: (_d = config.get.yond) === null || _d === void 0 ? void 0 : _d.excludeTarifsWithExternalCode,
            include: (_e = config.get.yond) === null || _e === void 0 ? void 0 : _e.includeTarifsWithExternalCode,
            studioLocationMapping: (_f = config.get.yond) === null || _f === void 0 ? void 0 : _f.studioLocationMapping,
            includeBenefitDescriptionWithExternalCode: (_g = config.get.yond) === null || _g === void 0 ? void 0 : _g.includeBenefitDescriptionWithExternalCode,
        };
    }
    else if (provider === 'themisoft') {
        data.provider = {
            name: 'themisoft',
            showPromotionalContracts: (_j = (_h = config.get.themisoft) === null || _h === void 0 ? void 0 : _h.showPromotionalContracts) !== null && _j !== void 0 ? _j : false,
        };
    }
    else if (provider === 'magicline') {
        data.provider = {
            name: "magicline",
            forceOpenAPI: (_l = (_k = config.get) === null || _k === void 0 ? void 0 : _k.forceOpenAPI) !== null && _l !== void 0 ? _l : false,
        };
    }
    return data;
}
